import { CLEAR_COMMENTS, UPDATE_COMMENTS, UPDATE_COMMENT, ADD_COMMENT,MASK_COMMENT } from "../reducers/actiontypes";

const initialState = (function(state) {
	return state || [];
})(window.commentstate.comments);

export default function(state=initialState, action) {
	switch (action.type) {
		case CLEAR_COMMENTS:
			return [];
		case UPDATE_COMMENTS:
			return action.comments;
		case UPDATE_COMMENT:
			return [...state.slice(0, action.index), action.comment, ...state.slice(action.index+1)];
		case ADD_COMMENT:
			if (action.parent_index > -1) {
				return [...state.slice(0,action.parent_index+1), action.comment, ...state.slice(action.parent_index+1)];
			}
			else {
				return [action.comment, ...state];
			}
		case MASK_COMMENT:
			return state.map((comment)=>comment.objectid===action.objectid?{
				_links: {},
				objectid: "n/a",
				body: "Deleted",
				creator: {},
				datetime_created: comment.datetime_created,
				timestamp: comment.timestamp,
				comment_type: "archived_" + comment.comment_type
			}:comment);
		default:
			return state;
	}
}